"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeSharingHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sdk_model_1 = require("@gooddata/sdk-model");
var dashboard_1 = require("../../events/dashboard");
var metaSelectors_1 = require("../../store/meta/metaSelectors");
var general_1 = require("../../events/general");
var meta_1 = require("../../store/meta");
var redux_batched_actions_1 = require("redux-batched-actions");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var loadDashboardPermissions_1 = require("./initializeDashboardHandler/loadDashboardPermissions");
var dashboardPermissions_1 = require("../../store/dashboardPermissions");
function createDashboardSaveSharingContext(cmd) {
    var newSharingProperties, persistedDashboard, filterContext, otherDashboardProps, filterContextProp, dashboardFromState, dashboardToSave;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newSharingProperties = cmd.payload.newSharingProperties;
                return [4 /*yield*/, effects_1.select(metaSelectors_1.selectPersistedDashboard)];
            case 1:
                persistedDashboard = _a.sent();
                ts_invariant_1.default(persistedDashboard, "Cant change sharing of unsaved dashboard");
                filterContext = persistedDashboard.filterContext, otherDashboardProps = tslib_1.__rest(persistedDashboard, ["filterContext"]);
                filterContextProp = sdk_model_1.isFilterContext(filterContext)
                    ? {
                        filterContext: filterContext,
                    }
                    : {};
                dashboardFromState = tslib_1.__assign(tslib_1.__assign({}, otherDashboardProps), filterContextProp);
                dashboardToSave = tslib_1.__assign(tslib_1.__assign({}, dashboardFromState), { shareStatus: newSharingProperties.shareStatus, isLocked: newSharingProperties.isLocked, isUnderStrictControl: newSharingProperties.isUnderStrictControl });
                return [2 /*return*/, {
                        cmd: cmd,
                        persistedDashboard: persistedDashboard,
                        dashboardToSave: dashboardToSave,
                    }];
        }
    });
}
function updateDashboard(ctx, saveSharingCtx) {
    return ctx.backend
        .workspace(ctx.workspace)
        .dashboards()
        .updateDashboard(saveSharingCtx.persistedDashboard, saveSharingCtx.dashboardToSave);
}
function getDashboard(ctx, dashboardRef) {
    return ctx.backend.workspace(ctx.workspace).dashboards().getDashboard(dashboardRef);
}
function changeGrantees(ctx, saveSharingCtx) {
    var _a = saveSharingCtx.cmd.payload.newSharingProperties, granteesToAdd = _a.granteesToAdd, granteesToDelete = _a.granteesToDelete;
    var grantees = tslib_1.__spread(granteesToAdd, granteesToDelete).filter(sdk_model_1.isGranularAccessGrantee);
    return ctx.backend.workspace(ctx.workspace).accessControl().changeAccess(ctx.dashboardRef, grantees);
}
function saveSharing(ctx, saveSharingCtx) {
    var _a, granteesToAdd, granteesToDelete, grantees, updatedDashboardPermissions, setDashboardPermissionsAction, dashboard, setDashboardMetaAction, batch;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = saveSharingCtx.cmd.payload.newSharingProperties, granteesToAdd = _a.granteesToAdd, granteesToDelete = _a.granteesToDelete;
                grantees = tslib_1.__spread(granteesToAdd, granteesToDelete).filter(sdk_model_1.isGranularAccessGrantee);
                if (!!isEmpty_1.default(grantees)) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.call(changeGrantees, ctx, saveSharingCtx)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [4 /*yield*/, effects_1.call(loadDashboardPermissions_1.loadDashboardPermissions, ctx)];
            case 3:
                updatedDashboardPermissions = _b.sent();
                setDashboardPermissionsAction = dashboardPermissions_1.dashboardPermissionsActions.setDashboardPermissions(updatedDashboardPermissions);
                if (!updatedDashboardPermissions.canViewDashboard) return [3 /*break*/, 8];
                if (!!ctx.backend.capabilities.supportsGranularAccessControl) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(updateDashboard, ctx, saveSharingCtx)];
            case 4:
                // update dashboard with specified share status
                dashboard = _b.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.call(getDashboard, ctx, saveSharingCtx.persistedDashboard.ref)];
            case 6:
                // get dashboard with computed share status from backend
                dashboard = _b.sent();
                _b.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                dashboard = saveSharingCtx.persistedDashboard;
                _b.label = 9;
            case 9:
                setDashboardMetaAction = meta_1.metaActions.setMeta({ dashboard: dashboard });
                batch = redux_batched_actions_1.batchActions([setDashboardMetaAction, setDashboardPermissionsAction], "@@GDC.DASH.SAVE_SHARING");
                return [2 /*return*/, {
                        batch: batch,
                        dashboard: dashboard,
                    }];
        }
    });
}
function changeSharingHandler(ctx, cmd) {
    var dashboardRef, saveSharingCtx, result, batch, dashboard, updatedDashboardProperties;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(metaSelectors_1.selectDashboardRef)];
            case 1:
                dashboardRef = _a.sent();
                if (!dashboardRef) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Dashboard to change its sharing status must have an ObjRef.");
                }
                return [4 /*yield*/, effects_1.call(createDashboardSaveSharingContext, cmd)];
            case 2:
                saveSharingCtx = _a.sent();
                return [4 /*yield*/, effects_1.call(saveSharing, ctx, saveSharingCtx)];
            case 3:
                result = _a.sent();
                batch = result.batch, dashboard = result.dashboard;
                if (!batch) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(batch)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                updatedDashboardProperties = tslib_1.__assign(tslib_1.__assign({}, cmd.payload.newSharingProperties), { shareStatus: dashboard.shareStatus });
                return [2 /*return*/, dashboard_1.dashboardSharingChanged(ctx, dashboardRef, updatedDashboardProperties, cmd.correlationId)];
        }
    });
}
exports.changeSharingHandler = changeSharingHandler;
//# sourceMappingURL=changeSharingHandler.js.map